module.exports = __webpack_public_path__ + "static/media/famiglia2.03646a71.jpeg";